import { useTranslation } from "react-i18next";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { VersionsTable } from "../../VersionsTable";
import { StorageObjectValue } from "../../../../services/api/instances/storageApi/types/service_types";
import { StorageObjectVersion } from "../../../../services/api/instances/storageApi/types/object_types";
import styles from "./styles.module.css";

interface Props<T extends StorageObjectValue> {
  versions: StorageObjectVersion<T>[];
  closeModal: () => void;
  modalType: string;
  onOk: (id: string) => void;
}

export const RestoreVersionModal = <T extends StorageObjectValue>(
  props: Props<T>,
) => {
  const { t } = useTranslation();

  return (
    <ModalBasic
      open={props.modalType === "restore"}
      title={t("versioning.restore_modal_title")}
      hasCloseButton
      onClose={props.closeModal}
      closeModal={props.closeModal}
      className={styles["modal"]}
    >
      <div className={styles.container}>
        <VersionsTable
          versions={props.versions}
          onOk={(id) => {
            props.closeModal();
            props.onOk(id);
          }}
        />
      </div>
    </ModalBasic>
  );
};
